import Footer, { socials } from "./footer";

export { socials };
export default Footer;
